import { useCallback, useEffect, useState } from 'react'

import {
  fetchAccountTargetTitleVariants,
  type AccountTargetTitleVariant,
} from '../lib/accountTargetTitleLibrary'
import { supabase } from '../lib/supabase'

export function useAccountTargetTitleLibrary(resumeId: string | undefined) {
  const [variants, setVariants] = useState<AccountTargetTitleVariant[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refresh = useCallback(async () => {
    if (!resumeId) {
      setVariants([])
      setError(null)
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)
    try {
      const result = await fetchAccountTargetTitleVariants(supabase, {
        currentResumeId: resumeId,
      })
      setVariants(result)
    } catch (err) {
      setVariants([])
      setError(err instanceof Error ? err.message : 'Failed to load target titles')
    } finally {
      setLoading(false)
    }
  }, [resumeId])

  useEffect(() => {
    void refresh()
  }, [refresh])

  return { variants, loading, error, refresh }
}
